import { render, staticRenderFns } from "./PosLayout.vue?vue&type=template&id=66afcc10&scoped=true"
import script from "./PosLayout.vue?vue&type=script&lang=js"
export * from "./PosLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66afcc10",
  null
  
)

export default component.exports